<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-06-21 16:35:26
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\BlockLeave\BlockLeaveMapping\BlockLeaveMapping.vue
 -->
<template>
  <ContentLayout
    pad="0"
    :title="$t('label_essweb_BlockLeaveMapping_list_title')"
    filterable
    :addBtn="hasBtn('add-admin-block-leave-mapping')"
    @new="$refs.groupMapping.new()"
    :importBtn="hasBtn('import-admin-block-leave-mapping')"
    :import-options="{
      api: '/block-leave-group-mapping/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/block-leave-group-mapping-import-template.xlsx',
      success: (result) => {
        if (selectOneStaff)
          getList(1, $tableSetting.perPageSize, () => {
            $store.dispatch('resetTable', new Date().getTime());
          });
      },
    }"
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(filter);
        "
        @update="
          (prop, value, selected) => {
            if (prop == 'department') curDept = value; //触发岗位更新下拉
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <v-card class="transparent d-flex flex-row rounded-lg" elevation="0">
        <!-- left -->
        <v-card
          class="fill-height white rounded-lg pa-0"
          elevation="0"
          width="280"
          :style="{
            minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
          }"
        >
          <!-- choose -->
          <noContent v-if="show_Staff.length == 0 && !staff_Loading" />
          <v-sheet
            v-if="staff_Loading"
            :style="{
              minHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="text-center d-flex align-center justify-center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              size="30"
              width="2"
            ></v-progress-circular>
          </v-sheet>
          <v-list
            dense
            v-if="!staff_Loading"
            :style="{
              maxHeight: $vuetify.breakpoint.height - 238 + 42 - 48 + 'px',
            }"
            class="scroll_content_y"
          >
            <v-list-item-group v-model="selectOneStaff" color="primary">
              <v-list-item
                v-for="(staff, index) in show_Staff"
                :key="`staff---${index}`"
                dense
                two-line
                :value="staff.staff_id"
                class="pa-0 px-2 ma-0"
              >
                <v-list-item-avatar size="36" class="pa-0 ma-0 mr-2">
                  <StaffAvatar
                    size="36"
                    :isTemp="staff.is_temp"
                    :src="staff.staff_avatar"
                    :staff_name="staff.preferred_name"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ $getCommonLangValue(staff.preferred_name) }}
                    <span class="text--secondary text-caption-xs">{{
                      staff.staff_code
                    }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-body-2">
                    {{ $getCommonLangValue(staff.job_post_name) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <!-- left -->
        <v-card
          class="ml-3 rounded-lg flex-grow-1"
          elevation="0"
          :style="{
            maxWidth: 'calc(100% - 292px)',
          }"
        >
          <Tabler
            :headers="headers"
            :items="desserts"
            list-type="client"
            :height="$vuetify.breakpoint.height - 275 - 48"
            :totalCount="totalCount"
            @change="
              (page, perpage, callback) => {
                getList(page, perpage, callback);
              }
            "
          >
            <template v-slot:item.block_leave_group_name="{ item }">
              {{ $getCommonLangValue(item.block_leave_group_name) }}
            </template>
            <template v-slot:item.year="{ item }">
              {{ item.year }}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="
                  $refs.groupMapping.edit(
                    selectOneStaff,
                    Number(item.year),
                    item.block_leave_group_uuid,
                    item.uuid
                  )
                "
                v-if="hasBtn('edit-admin-block-leave-mapping')"
              >
                <span class="material-icons-round">edit</span>
              </v-btn>
            </template>
          </Tabler>
        </v-card></v-card
      >
    </template>
    <template v-slot:tools-main>
      <groupMapping ref="groupMapping" @change="onChange" />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import groupMapping from "@/Page/EssAdmin/BlockLeave/BlockLeaveMapping/components/groupMapping";
export default {
  name: "BlockLeaveRecord",
  components: { groupMapping },
  computed: {
    ...mapGetters(["companyLang", "defaultUTC"]),
  },
  data() {
    return {
      showSelect: false,
      showDelete: false,
      selected: [],
      totalCount: 0,
      staff_Loading: false,
      allStaff: [],
      show_Staff: [],
      selectOneStaff: null,
      headers: [
        {
          text: "label_essweb_BlockLeaveMapping_form_YearLabel",
          value: "year",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_BlockLeavePolicy_list_BlockLeaveGroupNameLabel",
          value: "block_leave_group_name",
          tran: true,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      standard_working_minutes: 1,
      filterPageData: null,
      curDept: [],
      filterObjects: [
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_BlockLeaveMapping_list_staffLabel",
          value: [],
          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "org_level_name",
          name: "department",
          multiple: true,
          label: "label_essweb_UM_filters_departmentLabel",
          value: [],

          selected: [],
          data: {
            api: "/dept/get-tree/",
            url_type: "tree",
            args: null,
            table: "mrbase_sys_org_levels",
            type: "",
            modelKey: "org_level_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "job_post_name",
          name: "job",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobLabel",
          value: [],
          selected: [],
          data: {
            api: "/job-post/get-list/",
            url_type: "primary",
            args: { dept_uuid: "" },
            table: "mrbase_sys_job_posts",
            type: "",
            modelKey: "job_post_name",
            valueKey: "uuid",
            global: false,
          },
        },
      ],
    };
  },
  watch: {
    selectOneStaff(val) {
      const that = this;
      this.desserts = [];
      this.$Sleep(600).then(() => {
        if (val)
          that.getList(1, this.$tableSetting.perPageSize, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
      });
    },
    curDept(val) {
      //监听部门变化
      this.$fliterValue(this.filterObjects, "job", []);
      if (!val || val.length == 0) {
        this.filterObjects[2]["disabled"] = true;
      }
      if (val) {
        let arr = [];
        if (val.length) {
          this.filterObjects[2]["disabled"] = false;
          val.map((e) => {
            if (e && e.uuid) arr.push(e.uuid);
          });
          this.filterObjects[2]["data"]["args"]["dept_uuid"] = arr.join(",");
        } else {
          return;
        }
      }
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.getStaff();
  },
  filters: {},
  async created() {},
  methods: {
    getStaff(data) {
      this.staff_Loading = true;
      this.$getStaffList(Object.assign({}, data ? data : {})).then((res) => {
        this.allStaff = res;
        this.show_Staff = res;
        this.staff_Loading = false;
      });
    },
    toFilter(callback) {
      const that = this;
      this.desserts = [];
      this.selectOneStaff = null;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });
      this.getStaff(data);
    },
    toNew() {},
    toEditItem() {},
    onChange(staff) {
      if (this.selectOneStaff && staff == this.selectOneStaff)
        this.getList(1, this.$tableSetting.perPageSize, () => {
          this.$store.dispatch("resetTable", new Date().getTime());
        });
      else this.selectOneStaff = staff;
    },
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_block_leave_user_map_year",
        url: "/block-leave-group-mapping/get-list/",
        data: {
          staff_uuid: this.selectOneStaff,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
  },
};
</script>
